// TRO_Today_You_Are_Going_To_Read
export const demoVideoStart =
    "You're going to read two stories out loud and answer questions about them. Let's watch a video about the stories and questions before you begin.";

// TRO_Start_Reading_Page_Backup
export const bookStartGeneral =
    "This is the first book you're going to read. Remember to read the book out loud. Click the green arrow to begin."; // not used

// TRO_Mic_Access
export const trcMicPermission =
    'Before you start reading, we need to turn on your microphone. Click the green button. Then click "Allow" in the box that opens.';

// TRO_Test_Mic
export const trcMicTesting =
    'Now we need to make sure I can hear you. Click the "Start recording" button and then say, "The dog likes to play with the ball". When you are done speaking, click "Stop recording".';

// TRO_Test_Mic_Try_Again
export const trcMicTestRetry =
    'Let\'s try that again. Get closer to your device and speak as loudly and clearly as you can. Click "Start recording" and say, "The dog likes to play with the ball". When you are done speaking, click "Stop recording".';

// TRO_Test_Mic_Pass
export const trcMicTestSuccess = 'Click the green arrow to continue.';

// TRO_Remember_Read_Outloud
export const trcCountdownReminder = 'Remember to read out loud as clearly as you can.';

// TRO_Instructions_For_Questions
export const comprehensionReady =
    'The text you read is on the left. Read and answer the questions. Use the text if you need help answering the questions. You do this by clicking on the arrows at the bottom of the book page. Some questions will ask you to choose one answer. Some will ask you to choose two.';

// TRO_Read_Answer_Questions
export const comprehensionReplay =
    'The text you read is on the left. Read and answer the questions. Use the text if you need help answering the questions. You do this by clicking on the arrows at the bottom of the book page. Some questions will ask you to choose one answer. Some will ask you to choose two.';

// TRO_Test_Mic_Not_Reading_Loud_Enough
export const trcMicVerificationFailure =
    'We have to check a few more things before you start reading. Raise your hand for help.';

// TRO_Practice_Reading
export const troMicReadingCheck =
    'Now we are going to practice reading. Click "Start recording" and read the sentence on your screen out loud. When you are done reading, click "Stop recording".';

// TRO_Continue_Reading
export const troMultiChoiceReadingCheckInstructions =
    "Let's continue reading. Click the audio icon and listen to the sentence. Then click the button that shows the sentence you heard.";

// TRO_Test_Mic_Not_Reading_Loud_Enough_Again
export const thatDidntWorkTwo = "I'm sorry, that didn't work.";

// TRO_Done_Answering
export const comprehensionCompleteReminder = 'Are you done answering all the questions?';

// TRO_Done_Reading
export const bookCompleteReminder = 'Are you done reading?';

// TRO_Make_Sure
export const fluencyReminder = "Make sure you're reading.";

// TRO_Red_Bike
export const troMultiChoiceReadingCheckSentence = 'I have a red bike.';

// TRO_Reminder_Page_Backup
export const trcReminders =
    "You're going to read two books to me. Then you'll answer some questions. Remember to read the book out loud. Read all the words in the white area. Don't read any words in the dark area. You'll be able to see the words in the dark area after you stop the recording. Once you finish recording, you will see pages without the start recording and stop recording buttons. You should still continue to read the book out loud until you reach the end. Click the arrow to start reading the first book.";
